export function speak(text, callback) {
  const frVoices = speechSynthesis
    .getVoices()
    .filter(v => v.lang.indexOf("fr") >= 0);
  const utterance = new SpeechSynthesisUtterance();
  utterance.onend = () => {
    if (callback) {
      callback();
    }
  };
  if (frVoices.length > 0) {
    utterance.voice = frVoices[0];
  }
  utterance.lang = "fr-FR";
  utterance.text = text;
  speechSynthesis.speak(utterance);
}

window.SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition || null;

let recognizer;

export function listen(callback) {
  if (!recognizer) {
    recognizer = new window.SpeechRecognition();
    recognizer.continuous = true;
    recognizer.interimResults = false;
    recognizer.lang = "fr-FR";
    recognizer.onerror = function() {
      recognizer.stop();
    };
  }

  recognizer.onresult = function(event) {
    let textContent = "";
    for (var i = event.resultIndex; i < event.results.length; i++) {
      if (event.results[i].isFinal) {
        textContent = event.results[i][0].transcript; // + ' (Confidence: ' + event.results[i][0].confidence + ')';
      } else {
        textContent += event.results[i][0].transcript;
      }
    }
    // recognizer.stop();
    callback(textContent, recognizer);
  };
  recognizer.start();
}
